import Parse from 'parse';

export const getUrlVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return (false);
}

export const updateParseObject = (parseClass,parseObjectId,parseKey,parseValue) => {
  var Query = Parse.Object.extend(parseClass);
  var query = new Parse.Query(Query);
  query.get(parseObjectId,{
    success: function (result) {
        result.set(parseKey,parseValue)
        result.save(null, {
        success: function(result) {
          return result
        },
        error: function(result, error) {
          throw error;
        }
      });
    },
    error: function(error) {
        throw error;
    }
  })
}



// WEBPACK FOOTER //
// ./src/utilities.js